module.exports = __webpack_public_path__ + "img/data_icon8.37c6cea2.png";